import moment from "moment";

import { AnnouncementFormValues } from "../components";
import { AnnouncementsHistoryListItem } from "../content.types";

export const getInitialAnnouncementFormValues = (
  editableAnnouncement: AnnouncementsHistoryListItem | null
): AnnouncementFormValues => {
  return {
    title: editableAnnouncement?.title ?? "",
    text: editableAnnouncement?.text ?? "",
    image: editableAnnouncement?.image ?? null,
    shownToResellersUntilDate: editableAnnouncement
      ? new Date(editableAnnouncement.shownToResellersUntil)
      : null,
    shownToResellersUntilTime: editableAnnouncement
      ? moment(editableAnnouncement.shownToResellersUntil).format("HH:mm:ss")
      : "23:59:59"
  };
};
